import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/modules/shared/services/http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ReportService  extends HttpService {

  constructor(http: HttpClient) { 
    super('',http);
  }
 
  getFilter() {
    return this.get().map(res => {
      return res['data'];
    }); 
  }
  
  downloadPDF(url?:string) {
    return this.http.get(url, {observe: 'response', responseType: 'blob'}).map(res => {
      return new Blob([res.body], {type: res.headers.get('Content-Type')});
    });
  }
}
